function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 1C5.9 1 1 5.9 1 12s4.9 11 11 11 11-4.9 11-11S18.1 1 12 1zm1 15.2c0 .1 0 .1-.1.2 0 .1-.1.1-.1.2l-.1.1-.1.1c-.1 0-.1.1-.2.1s-.1.1-.2.1H12c-.1 0-.3 0-.4-.1-.1 0-.2-.1-.3-.2l-.1-.1c0-.1-.1-.1-.1-.2s-.1-.1-.1-.2V16c0-.3.1-.5.3-.7.1-.1.2-.2.3-.2.2-.1.4-.1.6-.1.1 0 .1 0 .2.1l.2.1.1.1c.2.2.3.4.3.7v.2zm0-4.2c0 .6-.4 1-1 1s-1-.4-1-1V8c0-.6.4-1 1-1s1 .4 1 1v4z",
  fill: "currentColor"
});

function SvgRoundAlertIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgRoundAlertIcon;